import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../lib/analytics";

/**
 * useAnalytics — auto-tracks screen views on route changes.
 * Mount once inside a Router context (e.g. Layout.jsx or App.js inner tree).
 */
export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    analytics.screen(analytics.resolve(location.pathname));
  }, [location.pathname]);
}
